import styled from "styled-components";

export const StyledCardContainer = styled.div`
  .container {
    flex: 0 50%;
    border: red solid;
    box-sizing: border-box;
  }
`;

export const StyledProgramOverviewCard = styled.div`
  max-width: 300px;
  width: 300px;
  box-sizing: border-box;
  margin: 0px 0px 12px 0px;
  height: 250px;
  padding: 0px 12px 12px !important;

  .card-portal-overview {
    width: 100%;
    min-width: 100%;
    margin: 0px;
    height: 250px;
  }

  .MuiTypography-h3 {
    font-family: inherit !important;
    font-size: 18px !important;
    font-weight: 700 !important;
    color: var(--colorTextPrimary) !important;
    max-width: 200px;
  }

  .MuiCardContent-root {
    padding: 0 16px !important;
    max-height: unset;
  }

  @media (min-width: 1200px) {
    .card-portal-overview {
      width: 100%;
      min-width: 100%;
      margin: 0px;
    }
  }
`;
